import(/* webpackMode: "eager" */ "/builds/91/yellosun/ysn-frontend/src/app/error.tsx");
